import snackbarSlice from './reducer'

export default snackbarSlice.reducer
